// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/federation/v1/federation.proto" (package "agency.federation.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Message } from "../../session/v1/session";
import { SessionConfig } from "../../session/v1/session";
import { Timestamp } from "../../../google/protobuf/timestamp";
/**
 * FederationHandshake establishes trust between harnesses.
 *
 * @generated from protobuf message agency.federation.v1.FederationHandshake
 */
export interface FederationHandshake {
    /**
     * source_harness_id identifies the initiating harness.
     *
     * @generated from protobuf field: string source_harness_id = 1
     */
    sourceHarnessId: string;
    /**
     * target_harness_id identifies the receiving harness.
     *
     * @generated from protobuf field: string target_harness_id = 2
     */
    targetHarnessId: string;
    /**
     * protocol_version is the federation protocol version.
     *
     * @generated from protobuf field: string protocol_version = 3
     */
    protocolVersion: string;
    /**
     * capabilities are advertised federation capabilities.
     *
     * @generated from protobuf field: repeated string capabilities = 4
     */
    capabilities: string[];
    /**
     * trust_level indicates the trust relationship.
     *
     * @generated from protobuf field: agency.federation.v1.TrustLevel trust_level = 5
     */
    trustLevel: TrustLevel;
    /**
     * timestamp is when the handshake was initiated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 6
     */
    timestamp?: Timestamp;
    /**
     * nonce is a random value for replay protection.
     *
     * @generated from protobuf field: string nonce = 7
     */
    nonce: string;
    /**
     * signature proves authenticity (signed with harness private key).
     *
     * @generated from protobuf field: bytes signature = 8
     */
    signature: Uint8Array;
}
/**
 * DelegateSession requests remote session execution.
 *
 * @generated from protobuf message agency.federation.v1.DelegateSession
 */
export interface DelegateSession {
    /**
     * request_id uniquely identifies this delegation request.
     *
     * @generated from protobuf field: string request_id = 1
     */
    requestId: string;
    /**
     * source_harness_id is the initiating harness.
     *
     * @generated from protobuf field: string source_harness_id = 2
     */
    sourceHarnessId: string;
    /**
     * target_harness_id is the executing harness.
     *
     * @generated from protobuf field: string target_harness_id = 3
     */
    targetHarnessId: string;
    /**
     * tenant is the tenant context.
     *
     * @generated from protobuf field: string tenant = 4
     */
    tenant: string;
    /**
     * workspace is the workspace context.
     *
     * @generated from protobuf field: string workspace = 5
     */
    workspace: string;
    /**
     * parent_session_id is the initiating session.
     *
     * @generated from protobuf field: string parent_session_id = 6
     */
    parentSessionId: string;
    /**
     * config is the session configuration.
     *
     * @generated from protobuf field: agency.session.v1.SessionConfig config = 7
     */
    config?: SessionConfig;
    /**
     * initial_messages are the starting conversation messages.
     *
     * @generated from protobuf field: repeated agency.session.v1.Message initial_messages = 8
     */
    initialMessages: Message[];
    /**
     * system_prompt is the system instruction.
     *
     * @generated from protobuf field: string system_prompt = 9
     */
    systemPrompt: string;
    /**
     * requested_at is when the delegation was requested.
     *
     * @generated from protobuf field: google.protobuf.Timestamp requested_at = 10
     */
    requestedAt?: Timestamp;
    /**
     * trace_id links to distributed trace.
     *
     * @generated from protobuf field: string trace_id = 11
     */
    traceId: string;
    /**
     * policy determines federation rules.
     *
     * @generated from protobuf field: agency.federation.v1.FederationPolicy policy = 12
     */
    policy: FederationPolicy;
    /**
     * encryption_required forces E2E encryption for responses.
     *
     * @generated from protobuf field: bool encryption_required = 13
     */
    encryptionRequired: boolean;
    /**
     * allowed_tools restricts which tools can be used remotely.
     *
     * @generated from protobuf field: repeated string allowed_tools = 14
     */
    allowedTools: string[];
}
/**
 * DelegateSessionResponse is the delegation result.
 *
 * @generated from protobuf message agency.federation.v1.DelegateSessionResponse
 */
export interface DelegateSessionResponse {
    /**
     * request_id matches the DelegateSession request.
     *
     * @generated from protobuf field: string request_id = 1
     */
    requestId: string;
    /**
     * accepted indicates if the delegation was accepted.
     *
     * @generated from protobuf field: bool accepted = 2
     */
    accepted: boolean;
    /**
     * remote_session_id is the session ID on the remote harness.
     *
     * @generated from protobuf field: string remote_session_id = 3
     */
    remoteSessionId: string;
    /**
     * reason explains rejection (if not accepted).
     *
     * @generated from protobuf field: string reason = 4
     */
    reason: string;
    /**
     * responded_at is when the response was sent.
     *
     * @generated from protobuf field: google.protobuf.Timestamp responded_at = 5
     */
    respondedAt?: Timestamp;
}
/**
 * FederationEvent signals cross-harness events.
 *
 * @generated from protobuf message agency.federation.v1.FederationEvent
 */
export interface FederationEvent {
    /**
     * event_id uniquely identifies this event.
     *
     * @generated from protobuf field: string event_id = 1
     */
    eventId: string;
    /**
     * source_harness_id is the originating harness.
     *
     * @generated from protobuf field: string source_harness_id = 2
     */
    sourceHarnessId: string;
    /**
     * event_type classifies the event.
     *
     * @generated from protobuf field: agency.federation.v1.FederationEventType event_type = 3
     */
    eventType: FederationEventType;
    /**
     * session_id is the related session (if applicable).
     *
     * @generated from protobuf field: string session_id = 4
     */
    sessionId: string;
    /**
     * timestamp is when the event occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 5
     */
    timestamp?: Timestamp;
    /**
     * metadata contains additional event context.
     *
     * @generated from protobuf field: map<string, string> metadata = 6
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * ForwardedIngress carries an ingress message forwarded from one harness to the harness
 * that owns the target session's claim. Published on the tenant account to:
 *   fed.<owner-harness-id>.ingress.<tenant>.<workspace>.<session>
 *
 * The receiving harness routes the message directly to the local SessionActor, bypassing
 * auth middleware (the forwarding harness already validated the JWT).
 *
 * @generated from protobuf message agency.federation.v1.ForwardedIngress
 */
export interface ForwardedIngress {
    /**
     * source_harness_id is the harness that forwarded this message.
     *
     * @generated from protobuf field: string source_harness_id = 1
     */
    sourceHarnessId: string;
    /**
     * tenant is the target tenant.
     *
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * workspace is the target workspace.
     *
     * @generated from protobuf field: string workspace = 3
     */
    workspace: string;
    /**
     * session is the target session ID.
     *
     * @generated from protobuf field: string session = 4
     */
    session: string;
    /**
     * envelope_bytes is the proto-marshaled Envelope from the original ingress message.
     * Contains validated JWT claims and the payload.
     *
     * @generated from protobuf field: bytes envelope_bytes = 5
     */
    envelopeBytes: Uint8Array;
    /**
     * original_subject is the NATS subject of the original ingress message.
     *
     * @generated from protobuf field: string original_subject = 6
     */
    originalSubject: string;
    /**
     * forwarded_at is when the forward was initiated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp forwarded_at = 7
     */
    forwardedAt?: Timestamp;
}
/**
 * RemoteHarnessStatus reports remote harness health.
 *
 * @generated from protobuf message agency.federation.v1.RemoteHarnessStatus
 */
export interface RemoteHarnessStatus {
    /**
     * harness_id identifies the remote harness.
     *
     * @generated from protobuf field: string harness_id = 1
     */
    harnessId: string;
    /**
     * connected indicates if the leafnode connection is active.
     *
     * @generated from protobuf field: bool connected = 2
     */
    connected: boolean;
    /**
     * last_heartbeat is the last heartbeat timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_heartbeat = 3
     */
    lastHeartbeat?: Timestamp;
    /**
     * protocol_version is the remote harness protocol version.
     *
     * @generated from protobuf field: string protocol_version = 4
     */
    protocolVersion: string;
    /**
     * capabilities are the remote harness capabilities.
     *
     * @generated from protobuf field: repeated string capabilities = 5
     */
    capabilities: string[];
    /**
     * active_sessions is the count of active federated sessions.
     *
     * @generated from protobuf field: int32 active_sessions = 6
     */
    activeSessions: number;
    /**
     * updated_at is when this status was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7
     */
    updatedAt?: Timestamp;
}
/**
 * FederationPolicy controls cross-harness communication rules.
 *
 * @generated from protobuf enum agency.federation.v1.FederationPolicy
 */
export enum FederationPolicy {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: FEDERATION_POLICY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * TENANT_ISOLATED restricts federation within tenant boundaries.
     *
     * @generated from protobuf enum value: FEDERATION_POLICY_TENANT_ISOLATED = 1;
     */
    TENANT_ISOLATED = 1,
    /**
     * CROSS_TENANT allows federation across tenants with explicit allowlist.
     *
     * @generated from protobuf enum value: FEDERATION_POLICY_CROSS_TENANT = 2;
     */
    CROSS_TENANT = 2
}
/**
 * TrustLevel defines federation trust levels.
 *
 * @generated from protobuf enum agency.federation.v1.TrustLevel
 */
export enum TrustLevel {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: TRUST_LEVEL_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * UNTRUSTED requires E2E encryption for all data.
     *
     * @generated from protobuf enum value: TRUST_LEVEL_UNTRUSTED = 1;
     */
    UNTRUSTED = 1,
    /**
     * TRUSTED allows plaintext within secure channel.
     *
     * @generated from protobuf enum value: TRUST_LEVEL_TRUSTED = 2;
     */
    TRUSTED = 2,
    /**
     * INTERNAL is for same-organization harnesses.
     *
     * @generated from protobuf enum value: TRUST_LEVEL_INTERNAL = 3;
     */
    INTERNAL = 3
}
/**
 * FederationEventType classifies federation events.
 *
 * @generated from protobuf enum agency.federation.v1.FederationEventType
 */
export enum FederationEventType {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: FEDERATION_EVENT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * HANDSHAKE_INITIATED indicates handshake started.
     *
     * @generated from protobuf enum value: FEDERATION_EVENT_TYPE_HANDSHAKE_INITIATED = 1;
     */
    HANDSHAKE_INITIATED = 1,
    /**
     * HANDSHAKE_COMPLETED indicates handshake succeeded.
     *
     * @generated from protobuf enum value: FEDERATION_EVENT_TYPE_HANDSHAKE_COMPLETED = 2;
     */
    HANDSHAKE_COMPLETED = 2,
    /**
     * HANDSHAKE_FAILED indicates handshake failed.
     *
     * @generated from protobuf enum value: FEDERATION_EVENT_TYPE_HANDSHAKE_FAILED = 3;
     */
    HANDSHAKE_FAILED = 3,
    /**
     * SESSION_DELEGATED indicates session delegation.
     *
     * @generated from protobuf enum value: FEDERATION_EVENT_TYPE_SESSION_DELEGATED = 4;
     */
    SESSION_DELEGATED = 4,
    /**
     * SESSION_COMPLETED indicates remote session completion.
     *
     * @generated from protobuf enum value: FEDERATION_EVENT_TYPE_SESSION_COMPLETED = 5;
     */
    SESSION_COMPLETED = 5,
    /**
     * SESSION_FAILED indicates remote session failure.
     *
     * @generated from protobuf enum value: FEDERATION_EVENT_TYPE_SESSION_FAILED = 6;
     */
    SESSION_FAILED = 6,
    /**
     * CONNECTION_LOST indicates leafnode disconnection.
     *
     * @generated from protobuf enum value: FEDERATION_EVENT_TYPE_CONNECTION_LOST = 7;
     */
    CONNECTION_LOST = 7,
    /**
     * CONNECTION_RESTORED indicates leafnode reconnection.
     *
     * @generated from protobuf enum value: FEDERATION_EVENT_TYPE_CONNECTION_RESTORED = 8;
     */
    CONNECTION_RESTORED = 8,
    /**
     * POLICY_VIOLATION indicates federation policy violation.
     *
     * @generated from protobuf enum value: FEDERATION_EVENT_TYPE_POLICY_VIOLATION = 9;
     */
    POLICY_VIOLATION = 9
}
// @generated message type with reflection information, may provide speed optimized methods
class FederationHandshake$Type extends MessageType<FederationHandshake> {
    constructor() {
        super("agency.federation.v1.FederationHandshake", [
            { no: 1, name: "source_harness_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "target_harness_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "protocol_version", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "32", pattern: "^[0-9]+\\.[0-9]+\\.[0-9]+$" } } } },
            { no: 4, name: "capabilities", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "50", items: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } } } },
            { no: 5, name: "trust_level", kind: "enum", T: () => ["agency.federation.v1.TrustLevel", TrustLevel, "TRUST_LEVEL_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 6, name: "timestamp", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 7, name: "nonce", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "16", maxLen: "128" } } } },
            { no: 8, name: "signature", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "buf.validate.field": { bytes: { minLen: "32", maxLen: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<FederationHandshake>): FederationHandshake {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sourceHarnessId = "";
        message.targetHarnessId = "";
        message.protocolVersion = "";
        message.capabilities = [];
        message.trustLevel = 0;
        message.nonce = "";
        message.signature = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<FederationHandshake>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FederationHandshake): FederationHandshake {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string source_harness_id */ 1:
                    message.sourceHarnessId = reader.string();
                    break;
                case /* string target_harness_id */ 2:
                    message.targetHarnessId = reader.string();
                    break;
                case /* string protocol_version */ 3:
                    message.protocolVersion = reader.string();
                    break;
                case /* repeated string capabilities */ 4:
                    message.capabilities.push(reader.string());
                    break;
                case /* agency.federation.v1.TrustLevel trust_level */ 5:
                    message.trustLevel = reader.int32();
                    break;
                case /* google.protobuf.Timestamp timestamp */ 6:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* string nonce */ 7:
                    message.nonce = reader.string();
                    break;
                case /* bytes signature */ 8:
                    message.signature = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FederationHandshake, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string source_harness_id = 1; */
        if (message.sourceHarnessId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sourceHarnessId);
        /* string target_harness_id = 2; */
        if (message.targetHarnessId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.targetHarnessId);
        /* string protocol_version = 3; */
        if (message.protocolVersion !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.protocolVersion);
        /* repeated string capabilities = 4; */
        for (let i = 0; i < message.capabilities.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.capabilities[i]);
        /* agency.federation.v1.TrustLevel trust_level = 5; */
        if (message.trustLevel !== 0)
            writer.tag(5, WireType.Varint).int32(message.trustLevel);
        /* google.protobuf.Timestamp timestamp = 6; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string nonce = 7; */
        if (message.nonce !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.nonce);
        /* bytes signature = 8; */
        if (message.signature.length)
            writer.tag(8, WireType.LengthDelimited).bytes(message.signature);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.federation.v1.FederationHandshake
 */
export const FederationHandshake = new FederationHandshake$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DelegateSession$Type extends MessageType<DelegateSession> {
    constructor() {
        super("agency.federation.v1.DelegateSession", [
            { no: 1, name: "request_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "source_harness_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "target_harness_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 5, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 6, name: "parent_session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 7, name: "config", kind: "message", T: () => SessionConfig, options: { "buf.validate.field": { required: true } } },
            { no: 8, name: "initial_messages", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Message, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "100" } } } },
            { no: 9, name: "system_prompt", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "524288" } } } },
            { no: 10, name: "requested_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 11, name: "trace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { len: "32", pattern: "^[0-9a-f]{32}$" } } } },
            { no: 12, name: "policy", kind: "enum", T: () => ["agency.federation.v1.FederationPolicy", FederationPolicy, "FEDERATION_POLICY_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 13, name: "encryption_required", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "allowed_tools", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "100", items: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_]*[a-z0-9]$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<DelegateSession>): DelegateSession {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestId = "";
        message.sourceHarnessId = "";
        message.targetHarnessId = "";
        message.tenant = "";
        message.workspace = "";
        message.parentSessionId = "";
        message.initialMessages = [];
        message.systemPrompt = "";
        message.traceId = "";
        message.policy = 0;
        message.encryptionRequired = false;
        message.allowedTools = [];
        if (value !== undefined)
            reflectionMergePartial<DelegateSession>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DelegateSession): DelegateSession {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_id */ 1:
                    message.requestId = reader.string();
                    break;
                case /* string source_harness_id */ 2:
                    message.sourceHarnessId = reader.string();
                    break;
                case /* string target_harness_id */ 3:
                    message.targetHarnessId = reader.string();
                    break;
                case /* string tenant */ 4:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 5:
                    message.workspace = reader.string();
                    break;
                case /* string parent_session_id */ 6:
                    message.parentSessionId = reader.string();
                    break;
                case /* agency.session.v1.SessionConfig config */ 7:
                    message.config = SessionConfig.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                case /* repeated agency.session.v1.Message initial_messages */ 8:
                    message.initialMessages.push(Message.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string system_prompt */ 9:
                    message.systemPrompt = reader.string();
                    break;
                case /* google.protobuf.Timestamp requested_at */ 10:
                    message.requestedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.requestedAt);
                    break;
                case /* string trace_id */ 11:
                    message.traceId = reader.string();
                    break;
                case /* agency.federation.v1.FederationPolicy policy */ 12:
                    message.policy = reader.int32();
                    break;
                case /* bool encryption_required */ 13:
                    message.encryptionRequired = reader.bool();
                    break;
                case /* repeated string allowed_tools */ 14:
                    message.allowedTools.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DelegateSession, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_id = 1; */
        if (message.requestId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestId);
        /* string source_harness_id = 2; */
        if (message.sourceHarnessId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sourceHarnessId);
        /* string target_harness_id = 3; */
        if (message.targetHarnessId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.targetHarnessId);
        /* string tenant = 4; */
        if (message.tenant !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 5; */
        if (message.workspace !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.workspace);
        /* string parent_session_id = 6; */
        if (message.parentSessionId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.parentSessionId);
        /* agency.session.v1.SessionConfig config = 7; */
        if (message.config)
            SessionConfig.internalBinaryWrite(message.config, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated agency.session.v1.Message initial_messages = 8; */
        for (let i = 0; i < message.initialMessages.length; i++)
            Message.internalBinaryWrite(message.initialMessages[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string system_prompt = 9; */
        if (message.systemPrompt !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.systemPrompt);
        /* google.protobuf.Timestamp requested_at = 10; */
        if (message.requestedAt)
            Timestamp.internalBinaryWrite(message.requestedAt, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string trace_id = 11; */
        if (message.traceId !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.traceId);
        /* agency.federation.v1.FederationPolicy policy = 12; */
        if (message.policy !== 0)
            writer.tag(12, WireType.Varint).int32(message.policy);
        /* bool encryption_required = 13; */
        if (message.encryptionRequired !== false)
            writer.tag(13, WireType.Varint).bool(message.encryptionRequired);
        /* repeated string allowed_tools = 14; */
        for (let i = 0; i < message.allowedTools.length; i++)
            writer.tag(14, WireType.LengthDelimited).string(message.allowedTools[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.federation.v1.DelegateSession
 */
export const DelegateSession = new DelegateSession$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DelegateSessionResponse$Type extends MessageType<DelegateSessionResponse> {
    constructor() {
        super("agency.federation.v1.DelegateSessionResponse", [
            { no: 1, name: "request_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "accepted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "remote_session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 4, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } },
            { no: 5, name: "responded_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<DelegateSessionResponse>): DelegateSessionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestId = "";
        message.accepted = false;
        message.remoteSessionId = "";
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial<DelegateSessionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DelegateSessionResponse): DelegateSessionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_id */ 1:
                    message.requestId = reader.string();
                    break;
                case /* bool accepted */ 2:
                    message.accepted = reader.bool();
                    break;
                case /* string remote_session_id */ 3:
                    message.remoteSessionId = reader.string();
                    break;
                case /* string reason */ 4:
                    message.reason = reader.string();
                    break;
                case /* google.protobuf.Timestamp responded_at */ 5:
                    message.respondedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.respondedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DelegateSessionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_id = 1; */
        if (message.requestId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestId);
        /* bool accepted = 2; */
        if (message.accepted !== false)
            writer.tag(2, WireType.Varint).bool(message.accepted);
        /* string remote_session_id = 3; */
        if (message.remoteSessionId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.remoteSessionId);
        /* string reason = 4; */
        if (message.reason !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.reason);
        /* google.protobuf.Timestamp responded_at = 5; */
        if (message.respondedAt)
            Timestamp.internalBinaryWrite(message.respondedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.federation.v1.DelegateSessionResponse
 */
export const DelegateSessionResponse = new DelegateSessionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FederationEvent$Type extends MessageType<FederationEvent> {
    constructor() {
        super("agency.federation.v1.FederationEvent", [
            { no: 1, name: "event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "source_harness_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "event_type", kind: "enum", T: () => ["agency.federation.v1.FederationEventType", FederationEventType, "FEDERATION_EVENT_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 4, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 5, name: "timestamp", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } }
        ]);
    }
    create(value?: PartialMessage<FederationEvent>): FederationEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.eventId = "";
        message.sourceHarnessId = "";
        message.eventType = 0;
        message.sessionId = "";
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<FederationEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FederationEvent): FederationEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string event_id */ 1:
                    message.eventId = reader.string();
                    break;
                case /* string source_harness_id */ 2:
                    message.sourceHarnessId = reader.string();
                    break;
                case /* agency.federation.v1.FederationEventType event_type */ 3:
                    message.eventType = reader.int32();
                    break;
                case /* string session_id */ 4:
                    message.sessionId = reader.string();
                    break;
                case /* google.protobuf.Timestamp timestamp */ 5:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* map<string, string> metadata */ 6:
                    this.binaryReadMap6(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap6(map: FederationEvent["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof FederationEvent["metadata"] | undefined, val: FederationEvent["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.federation.v1.FederationEvent.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: FederationEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string event_id = 1; */
        if (message.eventId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.eventId);
        /* string source_harness_id = 2; */
        if (message.sourceHarnessId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sourceHarnessId);
        /* agency.federation.v1.FederationEventType event_type = 3; */
        if (message.eventType !== 0)
            writer.tag(3, WireType.Varint).int32(message.eventType);
        /* string session_id = 4; */
        if (message.sessionId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.sessionId);
        /* google.protobuf.Timestamp timestamp = 5; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> metadata = 6; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.federation.v1.FederationEvent
 */
export const FederationEvent = new FederationEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ForwardedIngress$Type extends MessageType<ForwardedIngress> {
    constructor() {
        super("agency.federation.v1.ForwardedIngress", [
            { no: 1, name: "source_harness_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "session", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 5, name: "envelope_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "buf.validate.field": { bytes: { minLen: "1" } } } },
            { no: 6, name: "original_subject", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 7, name: "forwarded_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ForwardedIngress>): ForwardedIngress {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sourceHarnessId = "";
        message.tenant = "";
        message.workspace = "";
        message.session = "";
        message.envelopeBytes = new Uint8Array(0);
        message.originalSubject = "";
        if (value !== undefined)
            reflectionMergePartial<ForwardedIngress>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ForwardedIngress): ForwardedIngress {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string source_harness_id */ 1:
                    message.sourceHarnessId = reader.string();
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 3:
                    message.workspace = reader.string();
                    break;
                case /* string session */ 4:
                    message.session = reader.string();
                    break;
                case /* bytes envelope_bytes */ 5:
                    message.envelopeBytes = reader.bytes();
                    break;
                case /* string original_subject */ 6:
                    message.originalSubject = reader.string();
                    break;
                case /* google.protobuf.Timestamp forwarded_at */ 7:
                    message.forwardedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.forwardedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ForwardedIngress, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string source_harness_id = 1; */
        if (message.sourceHarnessId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sourceHarnessId);
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 3; */
        if (message.workspace !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.workspace);
        /* string session = 4; */
        if (message.session !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.session);
        /* bytes envelope_bytes = 5; */
        if (message.envelopeBytes.length)
            writer.tag(5, WireType.LengthDelimited).bytes(message.envelopeBytes);
        /* string original_subject = 6; */
        if (message.originalSubject !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.originalSubject);
        /* google.protobuf.Timestamp forwarded_at = 7; */
        if (message.forwardedAt)
            Timestamp.internalBinaryWrite(message.forwardedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.federation.v1.ForwardedIngress
 */
export const ForwardedIngress = new ForwardedIngress$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoteHarnessStatus$Type extends MessageType<RemoteHarnessStatus> {
    constructor() {
        super("agency.federation.v1.RemoteHarnessStatus", [
            { no: 1, name: "harness_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "connected", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "last_heartbeat", kind: "message", T: () => Timestamp },
            { no: 4, name: "protocol_version", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "32" } } } },
            { no: 5, name: "capabilities", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "50" } } } },
            { no: 6, name: "active_sessions", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<RemoteHarnessStatus>): RemoteHarnessStatus {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.harnessId = "";
        message.connected = false;
        message.protocolVersion = "";
        message.capabilities = [];
        message.activeSessions = 0;
        if (value !== undefined)
            reflectionMergePartial<RemoteHarnessStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoteHarnessStatus): RemoteHarnessStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string harness_id */ 1:
                    message.harnessId = reader.string();
                    break;
                case /* bool connected */ 2:
                    message.connected = reader.bool();
                    break;
                case /* google.protobuf.Timestamp last_heartbeat */ 3:
                    message.lastHeartbeat = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastHeartbeat);
                    break;
                case /* string protocol_version */ 4:
                    message.protocolVersion = reader.string();
                    break;
                case /* repeated string capabilities */ 5:
                    message.capabilities.push(reader.string());
                    break;
                case /* int32 active_sessions */ 6:
                    message.activeSessions = reader.int32();
                    break;
                case /* google.protobuf.Timestamp updated_at */ 7:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoteHarnessStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string harness_id = 1; */
        if (message.harnessId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.harnessId);
        /* bool connected = 2; */
        if (message.connected !== false)
            writer.tag(2, WireType.Varint).bool(message.connected);
        /* google.protobuf.Timestamp last_heartbeat = 3; */
        if (message.lastHeartbeat)
            Timestamp.internalBinaryWrite(message.lastHeartbeat, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string protocol_version = 4; */
        if (message.protocolVersion !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.protocolVersion);
        /* repeated string capabilities = 5; */
        for (let i = 0; i < message.capabilities.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.capabilities[i]);
        /* int32 active_sessions = 6; */
        if (message.activeSessions !== 0)
            writer.tag(6, WireType.Varint).int32(message.activeSessions);
        /* google.protobuf.Timestamp updated_at = 7; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.federation.v1.RemoteHarnessStatus
 */
export const RemoteHarnessStatus = new RemoteHarnessStatus$Type();
